import { History } from 'history';
import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import auth from "containers/SingIn/authSlice"

export const rootReducer = (history: History<unknown>) => combineReducers({
    router: connectRouter(history),
    auth: auth
  })